import { useSearchParams } from 'react-router-dom'

import { isPivotModeEnabled } from '../pivot/pivotMode'
import { CartDraftPanel } from './CartDraftPanel'
import { OrderBlankHistoryPanel } from './OrderBlankHistoryPanel'
import { OrdersScreen } from './OrdersScreen'

type RequestTab = 'draft' | 'history'

/**
 * Pivot «Заявка»: черновик (бывш. корзина) + история ранее сформированных заявок.
 */
export const RequestScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab: RequestTab = searchParams.get('tab') === 'history' ? 'history' : 'draft'
  const pivot = isPivotModeEnabled()

  const setTab = (next: RequestTab) => {
    const params = new URLSearchParams(searchParams)
    if (next === 'draft') {
      params.delete('tab')
    } else {
      params.set('tab', next)
    }
    setSearchParams(params, { replace: true })
  }

  return (
    <section className="market-page market-page--wide">
      <div className="market-request-tabs" role="tablist" aria-label="Разделы заявки">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'draft'}
          className={
            tab === 'draft'
              ? 'market-request-tabs__btn market-request-tabs__btn--active'
              : 'market-request-tabs__btn'
          }
          onClick={() => setTab('draft')}
        >
          Черновик
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'history'}
          className={
            tab === 'history'
              ? 'market-request-tabs__btn market-request-tabs__btn--active'
              : 'market-request-tabs__btn'
          }
          onClick={() => setTab('history')}
        >
          История
        </button>
      </div>
      {tab === 'draft' ? (
        <CartDraftPanel nested />
      ) : pivot ? (
        <OrderBlankHistoryPanel />
      ) : (
        <OrdersScreen embedded />
      )}
    </section>
  )
}
